<template>
  <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
    <el-form-item label="截至时间" prop="time">
      <el-date-picker
        v-model="form.time"
        type="datetime"
        placeholder="选择截至时间"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        :editable="false"
      ></el-date-picker>
    </el-form-item>
    <!-- 数值输入框 -->
    <el-form-item label="总采集量" prop="totalAmount">
      <el-input-number
        v-model="form.totalAmount"
        :min="0"
        placeholder="请输入总采集量"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="公众主问卷" prop="publicAmount">
      <el-input-number
        v-model="form.publicAmount"
        :min="0"
        placeholder="请输入公众主问卷采集量"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="公众专题问卷" prop="publicSpecialAmount">
      <el-input-number
        v-model="form.publicSpecialAmount"
        :min="0"
        placeholder="请输入公众专题问卷采集量"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="从业主问卷" prop="employmentAmount">
      <el-input-number
        v-model="form.employmentAmount"
        :min="0"
        placeholder="请输入从业主问卷采集量"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="从业专题问卷" prop="employmentSpecialAmount">
      <el-input-number
        v-model="form.employmentSpecialAmount"
        :min="0"
        placeholder="请输入从业专题问卷采集量"
      ></el-input-number>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
      <el-button @click="resetForm">清空</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'CustomForm',
  data() {
    return {
      form: {
        time: '',
        totalAmount: 0,
        publicAmount: 0,
        publicSpecialAmount: 0,
        employmentAmount: 0,
        employmentSpecialAmount: 0,
      },
      rules: {
        time: [
          { required: true, message: '请选择截至时间', trigger: 'change' }
        ],
        totalAmount: [
          { required: true, message: '请输入总采集量', trigger: 'blur' },
          { required: true, message: '请输入总采集量', trigger: 'change' },
        ],
        publicAmount: [
          { required: true, message: '请输入公众主问卷采集量', trigger: 'blur' },
          { required: true, message: '请输入公众主问卷采集量', trigger: 'change' },
        ],
        publicSpecialAmount: [
          { required: true, message: '请输入公众专题问卷采集量', trigger: 'blur' },
          { required: true, message: '请输入公众专题问卷采集量', trigger: 'change' },
        ],
        employmentAmount: [
          { required: true, message: '请输入从业主问卷采集量', trigger: 'blur' },
          { required: true, message: '请输入从业主问卷采集量', trigger: 'change' },
        ],
        employmentSpecialAmount: [
          { required: true, message: '请输入从业专题问卷采集量', trigger: 'blur' },
          { required: true, message: '请输入从业专题问卷采集量', trigger: 'change' },
        ],
      }
    };
  },
  methods: {
    submitForm() {
      // 触发表单提交事件，$emit 向上传递数据
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$set(this.form, 'name', '全国')
          this.$set(this.form, 'amount', this.form.publicAmount+this.form.employmentAmount)
          this.$set(this.form, 'specialAmount', this.form.publicSpecialAmount+this.form.employmentSpecialAmount)
          this.$emit('submit', this.form);
        } else {
          this.$message({
            message: '请完善数据再提交！',
            type: 'warning'
          });
          return false;
        }
      });
    },
    resetForm() {
      // 重置表单
      this.$refs.formRef.resetFields();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/placardInfo.vue